import OptionsItemsPointsComponent from "../../../../src/client/niv_acuteboekje/interactions/OptionsItemsPointsComponent.js";
import * as React from 'react';
export default {
  OptionsItemsPointsComponent,
  React
};